import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IChat } from "src/@types/chat";
import { getChatAsync } from "./actions";
import { ChatState } from "./slice";

type ActionReducerMapBuilderWithChatState = ActionReducerMapBuilder<ChatState>;

export const getChatReducer = (
  builder: ActionReducerMapBuilderWithChatState
) => {
  builder.addCase(getChatAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(
    getChatAsync.fulfilled,
    (state, action: PayloadAction<IChat>) => {
      state.isLoading = false;
      state.data = action.payload;
    }
  );

  builder.addCase(getChatAsync.rejected, (state) => {
    state.isLoading = false;
    state.data = null;
  });
};
